<app-main-page>
  <app-warehouses-list></app-warehouses-list>
</app-main-page>
